import React from 'react';
import type JiraBusinessSampleOnboardingAppType from '@atlassian/jira-spa-apps-business-sample-onboarding/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazySampleOnboardingView = lazyForPaint<typeof JiraBusinessSampleOnboardingAppType>(
	() =>
		import(
			/* webpackChunkName: "async-business-sample-onboarding", jiraSpaEntry: "async-business-sample-onboarding" */ '@atlassian/jira-spa-apps-business-sample-onboarding'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazySampleOnboardingView}
		pageId="async-business-sample-onboarding"
		shouldShowSpinner
	/>
);
